module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDAwIiBoZWlnaHQ9IjcwMCIgdmlld0JveD0iMCAwIDU2IDI4Ij48cGF0aCBmaWxsPSIjZDIwMDAwIiBkPSJNMCAwaDU2djI4SDB6Ii8+PGcgZmlsbD0iI2ZmZTYwMCI+PHBhdGggZD0iTTAgMGg4LjRMMjggMTMuNSA0Ny42IDBINTZMMCAyOGg4LjRMMjggMTQuNSA0Ny42IDI4SDU2em01NiAxMS4ydjUuNkwwIDExLjJ2NS42ek0yNS4yIDBMMjggMTJsMi44LTEyem0wIDI4TDI4IDE2bDIuOCAxMnoiLz48Y2lyY2xlIGN4PSIyOCIgY3k9IjE0IiByPSI0LjUiIHN0cm9rZT0iI2QyMDAwMCIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/mkd.svg
// module id = qa0Z
// module chunks = 0